import { getApi, postApi } from "../apiCall";

export const userAdminDetails = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/user/getAllUsers`;
  return postApi(url, payload);
};

export const userCompanyDetails = () => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/company/getFullCompanyDetails`;
  return getApi(url);
};

export const userConsumerDetails = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/consumerDetails/getAllConsumer`;
  return postApi(url, payload);
};

export const userGeneratorDetails = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/GeneratorDetails/getAllGenerators`;
  return postApi(url, payload);
};
